const SuperAdminLogin = (data) => {
  const authObject = {
    authToken: data.access_token,
    email: data.email,
    id: data.id,
    role: data.role,
  };
  return authObject;
};
const refreshToken = (data) => {
  console.log(data)
  const tokenState = JSON.parse(
    window.localStorage.getItem("LMS-" + process.env.REACT_APP_ENV)
  );
  const updatedState = {
    authState: {
      ...tokenState.authState,
      refreshToken: data.refresh_token,
      authToken: data.access_token,
    },
    generalState: tokenState.generalState,
  };
  window.localStorage.setItem(
    "LMS-" + process.env.REACT_APP_ENV,
    JSON.stringify(updatedState)
  );
  return {};
};
export { SuperAdminLogin, refreshToken };
